import { mapState } from 'vuex';

export default {
  props: {
    title: String,
    showExport: {
      type: Boolean,
      default: false,
    },
    tabs: {
      type: Array,
    },
    activeTab: {
      type: String,
      default: null,
    },
  },
  created() {
    if (this.activeTab) {
      this.onChange(this.activeTab);
    } else {
      this.onChange(this.tabs[0].name);
    }
  },
  data() {
    return {
      currentTab: null,
    };
  },
  methods: {
    onExport() {
      this.$emit('export', this.currentTab);
    },
    tabClass(item) {
      return (item.name === this.currentTab) ? 'account-desktop-header__button--active' : '';
    },
    onChange(name) {
      if (name !== this.currentTab) {
        this.currentTab = name;
        this.$emit('tabChange', name);
      }
    },
  },
  computed: {
    ...mapState('profile', ['transactionHistory', 'tradeHistory']),
    isExportAvailable() {
      let hasItems = false;
      switch (this.currentTab) {
        case 'trades':
          hasItems = true;
          // hasItems = this.tradeHistory &&
          //   this.tradeHistory.data &&
          //   this.tradeHistory.data.length > 0;
          break;
        case 'deposit-withdrawals':
          hasItems = this.transactionHistory &&
            this.transactionHistory.data &&
            this.transactionHistory.data.length > 0;
          break;
        default:
          break;
      }
      return this.showExport && hasItems;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-desktop-header/account-desktop-header.js